import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
interface ContactPageProps {
  onNavigate: (page: string) => void;
}
export function ContactPage({
  onNavigate
}: ContactPageProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen bg-cream py-20" data-id="element-475">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-476">
        <div className="text-center mb-16" data-id="element-477">
          <h1 className="font-heading text-5xl md:text-6xl text-charcoal uppercase tracking-wide mb-4" data-id="element-478">
            Get in <span className="text-victory-red" data-id="element-479">Touch</span>
          </h1>
          <p className="font-body text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-480">
            We'd love to hear from you. Whether you have a question about our
            menu, catering, or just want to say hello.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-481">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} className="bg-white rounded-3xl p-8 shadow-xl border border-amber/10" data-id="element-482">
            <h2 className="font-heading text-3xl text-charcoal uppercase mb-8" data-id="element-483">
              Send us a Message
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-484">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-485">
                <div data-id="element-486">
                  <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-487">
                    First Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-xl bg-cream border border-charcoal/10 focus:outline-none focus:ring-2 focus:ring-amber font-body" data-id="element-488" />
                </div>
                <div data-id="element-489">
                  <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-490">
                    Last Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-xl bg-cream border border-charcoal/10 focus:outline-none focus:ring-2 focus:ring-amber font-body" data-id="element-491" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-492">
                <div data-id="element-493">
                  <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-494">
                    Phone
                  </label>
                  <input type="tel" className="w-full px-4 py-3 rounded-xl bg-cream border border-charcoal/10 focus:outline-none focus:ring-2 focus:ring-amber font-body" data-id="element-495" />
                </div>
                <div data-id="element-496">
                  <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-497">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-3 rounded-xl bg-cream border border-charcoal/10 focus:outline-none focus:ring-2 focus:ring-amber font-body" data-id="element-498" />
                </div>
              </div>

              <div data-id="element-499">
                <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-500">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-xl bg-cream border border-charcoal/10 focus:outline-none focus:ring-2 focus:ring-amber font-body resize-none" data-id="element-501"></textarea>
              </div>

              <button type="submit" className="w-full bg-victory-red hover:bg-red-700 text-white font-heading text-xl py-4 rounded-xl shadow-lg transition-colors uppercase tracking-wider" data-id="element-502">
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} className="space-y-8" data-id="element-503">
            <div className="bg-charcoal text-white rounded-3xl p-8 shadow-xl" data-id="element-504">
              <h3 className="font-heading text-2xl uppercase mb-8 text-amber" data-id="element-505">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-506">
                <div className="flex items-start space-x-4" data-id="element-507">
                  <MapPinIcon className="w-6 h-6 text-victory-red flex-shrink-0 mt-1" data-id="element-508" />
                  <div data-id="element-509">
                    <h4 className="font-heading text-lg uppercase tracking-wide" data-id="element-510">
                      Location
                    </h4>
                    <p className="font-body text-white/70 mt-1" data-id="element-511">
                      7323 Landover Rd
                      <br data-id="element-512" />
                      Hyattsville, MD 20785
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-513">
                  <PhoneIcon className="w-6 h-6 text-victory-red flex-shrink-0 mt-1" data-id="element-514" />
                  <div data-id="element-515">
                    <h4 className="font-heading text-lg uppercase tracking-wide" data-id="element-516">
                      Phone
                    </h4>
                    <p className="font-body text-white/70 mt-1" data-id="element-517">
                      +1 (301) 386-6105
                      <br data-id="element-518" />
                      +1 (301) 787-9367
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-519">
                  <MailIcon className="w-6 h-6 text-victory-red flex-shrink-0 mt-1" data-id="element-520" />
                  <div data-id="element-521">
                    <h4 className="font-heading text-lg uppercase tracking-wide" data-id="element-522">
                      Email
                    </h4>
                    <p className="font-body text-white/70 mt-1" data-id="element-523">
                      victorykitchen82@gmail.com
                      <br data-id="element-524" />
                      info@victorykitchenz.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-amber/10 rounded-3xl p-8 border border-amber/20" data-id="element-525">
              <div className="flex items-center space-x-4 mb-4" data-id="element-526">
                <ClockIcon className="w-8 h-8 text-charcoal" data-id="element-527" />
                <h3 className="font-heading text-2xl text-charcoal uppercase" data-id="element-528">
                  Delivery Hours
                </h3>
              </div>
              <p className="font-body text-charcoal/80 text-lg" data-id="element-529">
                <strong data-id="element-530">12 noon – 8pm</strong>
              </p>
              <p className="font-body text-charcoal/60 mt-2" data-id="element-531">
                Delivery available around the DMV metro area.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}